import { Box } from '@cp/ds/src/components/box';
import React from 'react';
import { RouteConfigComponentProps } from 'react-router-config';
import Header from 'src/widgets/header';
// import { Feedbacks } from '../../shared/components/siteFeedback';
import { usePageMetaTags } from '../../shared/hooks/useMetaTags';
import { PageMetaTags } from '../../shared/components/layout/components/meta';
import { FeedbacksList } from './components/feedbacksList';
import { FeedbacksRules } from './components/feedbacksRules';

const FeedbacksPage: React.FC<RouteConfigComponentProps> = () => {
  const renderConfig = usePageMetaTags();

  return (
    <Box component="section">
      <PageMetaTags renderConfig={renderConfig} />

      <Header />
      <FeedbacksList />
      {/* <Feedbacks sx={{ alignItems: 'flex-start' }} /> */}
      <FeedbacksRules />
    </Box>
  );
};

export default FeedbacksPage;
